<template>
  <div>
    <b-form-group label="Mese">
      <b-form-select id="i-month" :options="months" v-model="filter.month" @change="refreshFilter"></b-form-select>
    </b-form-group>
    <b-form-group label="Anno">
      <b-form-select id="i-year" :options="years" v-model="filter.year" @change="refreshFilter"></b-form-select>
    </b-form-group>
    <b-form-group label="Dipendente">
      <b-select :options="employees" v-model="filter.employee" text-field="name" value-field="id" @change="refreshFilter">
        <template #first>
          <b-form-select-option :value="null"></b-form-select-option>
        </template>
      </b-select>
    </b-form-group>
    <b-button @click="clear">Pulisci</b-button>
  </div>
</template>

<script>
import rendicontazioneService from '@/services/rendicontazioneService'
import { mapGetters, mapActions } from 'vuex';
import LunchTicketFilter from '@/models/LunchTicketFilter';

export default {
  name: 'LunchTicketSearch',
  created() {
    this.months = [
      { text: 'Gennaio', value: 1 },
      { text: 'Febbraio', value: 2 },
      { text: 'Marzo', value: 3 },
      { text: 'Aprile', value: 4 },
      { text: 'Maggio', value: 5 },
      { text: 'Giugno', value: 6 },
      { text: 'Luglio', value: 7 },
      { text: 'Agosto', value: 8 },
      { text: 'Settembre', value: 9 },
      { text: 'Ottobre', value: 10 },
      { text: 'Novembre', value: 11 },
      { text: 'Dicembre', value: 12 }
    ]
    this.years = this.generateYearOptions()

    rendicontazioneService.fetchOnlyExportedUsersData()
      .then(data => { this.employees = data })
    // read filter from vuex
    this.filter = this.getFilter;
  },
  data() {
    return {
      filter: new LunchTicketFilter(),
      months: null,
      years: null,
      employees: []
    }
  },
  computed: {
    ...mapGetters({
      getFilter: 'lunchTicketFilter'
    })
  },
  methods: {
    generateYearOptions() {
      const olderYear = 2007;
      const currentYear = new Date().getFullYear();
      const years = Array.from({ length: (currentYear - olderYear) / 1 + 1 }, (_, i) => currentYear - i);
      return years.map(y => ({ text: y, value: y }))
    },
    refreshFilter() {
      this.setLunchTicketFilter(Object.assign({}, this.filter));
    },
    clear() {
      this.filter = new LunchTicketFilter();
      this.refreshFilter();
    },
    ...mapActions(['setLunchTicketFilter'])
  }
}
</script>
